import { UseWispoListParams, useWispoList } from '@webinex/wispo';
import { wispoClient } from './wispoClient';

export const useAppWispoList = (config: UseWispoListParams) =>
  useWispoList({ ...config, client: wispoClient });
